import { GET_CUMULIO_SCENARIO_SSO } from '../../shared/api/reports';

import FullCumulioDashboard from '../../shared/components/FullCumulioDashboard/FullCumulioDashboard';

const ScenarioOverview = () => {
	return (
		<>
			<div className="relative py-6">
				<FullCumulioDashboard
					queryKey="cumulio-scenario-overview"
					ssoQuery={GET_CUMULIO_SCENARIO_SSO}
					showLoading={false}
				/>
			</div>
		</>
	);
};

export default ScenarioOverview;
